module.exports = __webpack_public_path__ + "static/zh-Hant-52c0cbacba5846358232ab5ada110cd8.png";